import { createNode } from '@glueapp/graph-types';
import { DataValue } from '@glueapp/graph-types';

export const ReverseList = createNode({
    id: 'Reverse List',
    name: 'Reverse List',
    description: 'Reverses the order order of the items in the list, Example [8, 3, 2, 5] becomes [5, 2, 3, 8]',
    aiDescription: 'Reverses the order of items in a list. Connect a list to "List". Output: "Reversed List".',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
    },
    outPorts: {
        'Reversed List': {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
    },
    execute: function (input) {
        const inputArray = input.inPorts.List;
        return { output: { 'Reversed List': Array.from(inputArray).reverse() as DataValue[] } };
    },
});
